$ = require 'jquery'
h = require './helpers'

images_url = '//www.tourtrans.ru/js/online-styles/new/'

class AutobusQuotes
  addTpl: ->
    if $('.tabs').length > 0
      return
    block = require './../html/autobus_quotes.html'
    $('#aspnetForm #ctl00_generalContent_upFilter').prepend(block)
    $('#aspnetForm').closest('table').attr('cellspacing', 0)

    $form = $('#aspnetForm')

    $staff = $form.children()
    [$filters, $wrapper] = h.rowN(true, 'filter-content')
    $filters.appendTo $form
    $wrapper.append $staff

#    $('.notice-content').remove();
#    [$notice, $wrapper] = h.rowN(true, 'notice-content')
#    $wrapper.html 'Уважаемые туристы и коллеги!<br>
#      Обращаем Ваше внимание, что на некоторые туры и даты цена указана без учета топливного сбора. Полную стоимость можно будет увидеть в корзине при бронировании.
#      Размер топливного сбора (см. <a href="https://www.tourtrans.ru/pages/site/tsbor.html" target="_blank">здесь</a>).'
#    $notice.insertBefore $filters

    $('.legend-content').remove();
    [$legend, $wrapper] = h.rowN(true, 'legend-content')
    $legend.appendTo $form
    $wrapper.html 'DOUBLE - Двухместное размещение, 2 взрослых на одной семейной кровати.<br>
      ½ TWIN (ПОДБОР ПАРЫ)- Размещение в двухместном номере с подбором пары (2 взрослых на раздельных кроватях). Подбор пары не гарантируется.<br>
      TWIN - Двухместное размещение в номере (2 взрослых на раздельных кроватях).<br>
      SINGLE - Одноместное размещение взрослого в номере (по запросу).<br>
      TRIPLE (DBL +EX.BED ДО 18 ЛЕТ) - 3-х местное размещение в номере (2 взрослых на семейной кровати и 1 ребенок на дополнительном месте до 18 лет).<br>
      TRIPLE (TWIN+EX.BED ДО 18 ЛЕТ) - 3-х местное размещение в номере (2 взрослых на раздельных кроватях и 1 ребенок на дополнительном месте до 18 лет).'

    $('.filter-content .wrapper > br').remove()

    $results = h.rowN(false, 'results-content')
    $results.appendTo $form

    # Результаты поиска
    $results.append $('#ctl00_generalContent_upTable')


  applyStyles: ->
#    return

#    $('body').addClass('autobus_quotes')

    @addTpl()
    @applyFilters()

    $('#ctl00_generalContent_autobusFilter_TourTypeListPanel').mCustomScrollbar
      theme: 'dark-thick'
    $('#ctl00_generalContent_autobusFilter_TourListPanel').mCustomScrollbar
      theme: 'dark-thick'

  applyFilters: ->
    $search = $('#ctl00_generalContent_autobusFilter_txtTourName')

    $search.appendTo $('.search') # OK
    $search.attr('placeholder', 'Введите название тура')
    $('#search').replaceWith($search);
#    $search.attr('id', 'search')
    $city = $('#ctl00_generalContent_autobusFilter_ddlDepartFrom')
    $('#city').replaceWith($city)
    $filters = $('#ctl00_generalContent_upFilter > table')
    $filters.addClass('upFilter')
    $filters.appendTo $('.tours-select') # OK

    $label = $('#ctl00_generalContent_autobusFilter_lbTourType')
    $label.addClass('label pull-left').text('Тип тура')
    $tmp = $label.next()
    if $tmp.is('br')
      $tmp.remove() # br

    $type_cont = $label.parent()
    $type_cont.addClass('type-container')
    $type_cont.find('select').remove()
    $type_cont.children('label').addClass('pull-left').next().css('clear', 'both')

    $label = $('#ctl00_generalContent_autobusFilter_lbTour')
    $label.addClass('label pull-left').text('Тур')
    $tmp = $label.next()
    if $tmp.is('br')
      $tmp.remove() # br

    $tour_cont = $label.parent()
    $tour_cont.addClass('tour-container')
#    $tour_cont.find('br').remove();
    $tour_cont.children('label').addClass('pull-left').next().css('clear', 'both')
#    $tour_cont.find('input[type="text"]').remove()

    $date_from = $('#ctl00_generalContent_autobusFilter_mtdpTourDates_TxtMultiDatepickerFrom')
    $date_from_calendar = $('#ctl00_generalContent_autobusFilter_mtdpTourDates_PopMultiDatepickerFrom_Control')
    $('.date-from').empty().append($date_from)
    $('.date-from').next().empty().append($date_from_calendar)

    $date_to = $('#ctl00_generalContent_autobusFilter_mtdpTourDates_TxtMultiDatepickerTo')
    $date_to_calendar = $('#ctl00_generalContent_autobusFilter_mtdpTourDates_PopMultiDatepickerTo_Control')
    $('.date-to').empty().append($date_to)
    $('.date-to').next().empty().append($date_to_calendar)

    $duration_from = $('#ctl00_generalContent_autobusFilter_tbFrom')
    $duration_to = $('#ctl00_generalContent_autobusFilter_tbTo')
    $('.duration-from').empty().append($duration_from)
    $('.duration-to').empty().append($duration_to)

    $price_from = $('#ctl00_generalContent_autobusFilter_tbPriceFrom')
    $price_to = $('#ctl00_generalContent_autobusFilter_tbPriceTo')
    $('.price-from').empty().append($price_from)
    $('.price-to').empty().append($price_to)

    $('.notice-and-submit').click (e) ->
      e.preventDefault()
      $('#ctl00_generalContent_btnShow').click()

    # Переключатель валют
    $('#ctl00_generalContent_autobusFilter_currencySelector_curList_1').next().text('Р')
    $('input[name="ctl00$generalContent$autobusFilter$currencySelector$curList"]').change (e) ->
      if $(e.target).attr('id') == 'ctl00_generalContent_autobusFilter_currencySelector_curList_0'
        $other = $('#ctl00_generalContent_autobusFilter_currencySelector_curList_1')
      else
        $other = $('#ctl00_generalContent_autobusFilter_currencySelector_curList_0')
      checked = $(e.target).prop('checked')
      if checked
#        console.log $(e.target).attr('id')
        $(e.target).next().addClass('active')
        $other.next().removeClass('active')
#      else
#        $(e.target).next().removeClass('active')
#        $other.next().addClass('active')
    $('input[name="ctl00$generalContent$autobusFilter$currencySelector$curList"]').change() # Инициализация состояния

#    $('.currency-selector').empty().append($('#ctl00_generalContent_autobusFilter_currencySelector_curList'))
    $('.currency-selector').append($('#ctl00_generalContent_autobusFilter_currencySelector_curList'))

    # Кнопка "Показать"
    $('#ctl00_generalContent_btnShow').hide()

    # Наличие мест
    $placesAvailability = $('#ctl00_generalContent_autobusFilter_pnQuotaFilter')
    $('.places').append($placesAvailability)
#    $('.places').empty().append($placesAvailability)

    $(document).off('click.placesAvailability').on 'click.placesAvailability', '#ctl00_generalContent_autobusFilter_pnQuotaFilter span', (e) ->
      $(e.target).find('input[type="checkbox"]').click()

    $(document).off('change.placesAvailability').on 'change.placesAvailability', '#ctl00_generalContent_autobusFilter_pnQuotaFilter input[type="checkbox"]', (e) ->
      checked = $(e.target).prop('checked')
      if checked
        $(e.target).closest('span').addClass('checked')
      else
        $(e.target).closest('span').removeClass('checked')

    $('#ctl00_generalContent_autobusFilter_pnQuotaFilter input[type="checkbox"]').change() # Инициализация состояния

    $('.autobusQuotesBusPlanPopup').each (i, e) ->
      $image = $(e).prev().find('input')
      $image.addClass('bus-popup-btn')
      $image.attr('src', '')
#      $image.attr('src', images_url + 'autobus_orange.png')


module.exports = new AutobusQuotes